import moment from 'moment';
import * as actions from './../../redux/actions';
import * as selectors from './../../redux/selectors';
import { useEffect, useState } from 'react';
import { Button, Card, Dimmer, Form, Loader, Table } from 'semantic-ui-react';
import { TextField } from '../common/FormFields';
import * as campaignApi from './../../api/campaignApi';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
export const MailChimpSection = ({ id, user, formik }) => {
  const [loading, setLoading] = useState(true);
  const [mcStatus, setMcStatus] = useState({});

  const getStats = () => {
    campaignApi
      .getMailchimpStatus(id)
      .then(setMcStatus)
      .catch(() => setMcStatus({}))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getStats();
    }, 1 * 5000);
    return () => clearInterval(interval);
  }, [id]);

  return (
    <>
      <Card fluid>
        <Dimmer active={loading} inverted>
          <Loader inline>Getting Mailchimp Data...</Loader>
        </Dimmer>
        <Card.Content>
          <h5>MailChimp</h5>
        </Card.Content>
        <Card.Content>
          <Table collapsing celled compact="very" definition>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Emails sent:</Table.Cell>
                <Table.Cell>
                  {mcStatus?.emails_sent ? `${mcStatus?.emails_sent} of ${mcStatus.recipients?.recipient_count}` : ''}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Send time:</Table.Cell>
                <Table.Cell>
                  {mcStatus?.send_time && moment(mcStatus?.send_time).isValid()
                    ? moment(mcStatus?.send_time).format('LLL')
                    : ''}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Subject line:</Table.Cell>
                <Table.Cell>
                  <a href={mcStatus?.long_archive_url} target="_blank" rel="noreferrer">
                    {mcStatus?.settings?.subject_line}
                  </a>{' '}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Preview text:</Table.Cell>
                <Table.Cell>{mcStatus?.settings?.preview_text}</Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell>Status:</Table.Cell>
                <Table.Cell>{mcStatus?.status}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Audience</Table.Cell>
                <Table.Cell>{mcStatus?.recipients?.list_name}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          {user.isAdmin && (
            <Form.Field>
              <TextField
                name="utm"
                formik={formik}
                value={formik.values.utm}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.utm)}
                errorMessage={formik.errors.utm}
                label="UTM campaign"
              />
            </Form.Field>
          )}

          <br />

          {id && (
            <Button
              icon="refresh"
              labelPosition="left"
              disabled={loading}
              content="Refresh Status"
              onClick={getStats}
            />
          )}
          {id && (
            <Button
              disabled={loading}
              icon="cancel"
              labelPosition="left"
              content="Unschedule Email"
              onClick={() => {
                setLoading(true);
                campaignApi
                  .unschedule(id)
                  .then(getStats)
                  .then(res => {
                    formik.setFieldValue('isScheduled', false);
                    formik.setFieldValue('mailchimpCampaignId', null);
                  });
              }}
            />
          )}
        </Card.Content>
      </Card>
    </>
  );
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
  cities: selectors.getCityOptions(state),
  sites: selectors.getSiteOptions(state),
  topPostResults: selectors.getTopPosts(state),
  searchPostResults: selectors.getSearchPosts(state),
  currentDigest: selectors.getCurrentDigest(state),
  dayOptions: selectors.getDayOptions(state),
  user: selectors.users.current(state),
  series: selectors.series.series(state),
});

const mapDispatchToProps = dispatch => ({
  clearRecentPosts: bindActionCreators(actions.campaign.clearRecentPosts, dispatch),
  clearCurrentDigestSuccess: bindActionCreators(actions.campaign.clearCurrentDigestSuccess, dispatch),
  addDailyDigest: bindActionCreators(actions.campaign.addDailyDigest, dispatch),
  updateDailyDigest: bindActionCreators(actions.campaign.updateDailyDigest, dispatch),
  getTopPosts: bindActionCreators(actions.campaign.getTopPosts, dispatch),
  searchPosts: bindActionCreators(actions.campaign.searchDigests, dispatch),
  getDigestById: bindActionCreators(actions.campaign.getDigestById, dispatch),
  getSeries: bindActionCreators(actions.series.getSeries, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  deleteDigestById: bindActionCreators(actions.campaign.deleteDigestById, dispatch),
  getDigestTestEmail: bindActionCreators(actions.campaign.getDigestTestEmail, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MailChimpSection);
